import "./common.css"

// import { ToastContainer } from "react-toastify";
import { BrowserRouter as Router } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import AppRoutes from "./routes/AppRoutes.jsx";

function App() {
  return (
    <HelmetProvider>
      <Router>
        <AppRoutes />
        {/* <ToastContainer closeOnClick pauseOnHover draggable /> */}
      </Router>
    </HelmetProvider>
  );
}

export default App;